import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiMbaasService {
  // public urlServidor=`https://integrador.davivienda.com.sv:8443/WebServiceIntegracionMBAASLab/webapp`;//LAB
  // public urlServidor=` https://uat.davivienda.com.sv:8443/WebServiceIntegracionMBAASWL/webapp`;  
  public urlServidor=`https://www.davivienda.com.sv/IntegracionDigital/webapp`;  //PROD
  // public urlServidor=`https://daviviendaenlinea.davivienda.com.sv:4443/IntegracionDigital/webapp`;  //PRE-PROD
  //public urlServidor=`https://uat.davivienda.com.sv:8443/IntegracionDigital/webapp`;  //DESA

  constructor(private http:HttpClient) { }

  public postMetodo(microServicio, data):Observable<any>{
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let url=`${this.urlServidor}${microServicio}`;
    let body=JSON.stringify(data);
    return this.http.post(url, body,{ headers });
  }
}
